module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Nazim Emini — Senior Software Engineer","short_name":"Nazim Emini","description":"Senior Software Engineer specializing in distributed .NET microservices, Vue 3, and Azure.","start_url":"/","background_color":"#0c0d10","theme_color":"#0057ff","display":"standalone","icon":"src/assets/images/favicon-512.png","icon_options":{"purpose":"any maskable"},"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"168e36dea0f6b602f772348b1ca7bb08"},
    },{
      plugin: require('../gatsby-browser.ts'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
